import React from 'react';
import { View } from 'react-native';
import { CHAT_ROW, CHAT_SKELETON } from '../../constants';
import type { TChatChannelSkeletonRowProps } from '../../types';
import { ChatSkeletonBar } from './ChatSkeletonBar';

export const ChatChannelSkeletonRow = ({ dimmed }: TChatChannelSkeletonRowProps) => (
    <View
        style={{ height: CHAT_ROW.height, opacity: dimmed ? CHAT_SKELETON.dimmedRowOpacity : 1 }}
        className="flex-row items-center px-md gap-sm border-b border-gray-300"
    >
        <ChatSkeletonBar className="rounded-full" style={{ width: CHAT_ROW.avatarSize, height: CHAT_ROW.avatarSize }} />
        <View className="flex-1 gap-2">
            <ChatSkeletonBar className="w-1/2" style={CHAT_SKELETON.textBar} />
            <ChatSkeletonBar className="w-2/3" style={CHAT_SKELETON.textBar} />
        </View>
    </View>
);
